import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router";

import { TopNav } from "@/components/layout/TopNav";
import { NavigationProgress } from "@/components/feedback/PageLoader";

export function AppShell() {
  const location = useLocation();
  const previousPath = useRef(location.pathname);
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    if (previousPath.current === location.pathname) return;
    previousPath.current = location.pathname;
    setNavigating(true);
    const t = window.setTimeout(() => setNavigating(false), 420);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-bg-subtle text-foreground">
      <NavigationProgress active={navigating} />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-md focus:bg-primary focus:px-3 focus:py-2 focus:text-primary-foreground focus:shadow-soft-md"
      >
        Skip to content
      </a>
      <header
        data-app-header
        className="sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur-xl supports-[backdrop-filter]:bg-background/75"
      >
        <TopNav />
      </header>
      <main
        id="main"
        key={location.pathname}
        className="container animate-fade-in py-8"
      >
        <Outlet />
      </main>
    </div>
  );
}
